import styled from 'styled-components';

export const Container = styled.div`
  .MuiStepIcon-root,
  .MuiStepLabel-label {
    color: ${({ theme }) => theme.pantone2726C};

    .MuiStepIcon-text {
      display: none;
    }
  }
  .MuiStepLabel-label {
    font-size: 1rem;
  }

  .MuiStepConnector-lineVertical,
  .MuiStepConnector-vertical {
    display: none;
  }
`;

export const CardCompany = styled.div`
  background-color: ${({ theme }) => theme.grayLight};
  margin-bottom: 1rem;
  padding: .5rem;
`;

export const ContainerInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerLocation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0.5rem 0 0;
`;

export const Location = styled.p`
  white-space: nowrap;
`;

export const ColumnInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const State = styled.p`
  margin-bottom: 0;
  font-weight: bold;
  color: ${({ theme }) => theme.pantone2726C};
`;